import { useLocation } from 'react-router-dom';
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from '@/components/ui/breadcrumb';

const routeNameMap: Record<string, string> = {
  '/admin': 'Dashboard',
  '/admin/posts': 'Posts',
  '/admin/posts/new': 'New Post',
  '/admin/media': 'Media Library',
  '/admin/categories': 'Categories',
  '/admin/tags': 'Tags',
  '/admin/analytics': 'Analytics',
  '/admin/settings': 'Settings',
};

export const AdminBreadcrumb = () => {
  const location = useLocation();
  const pathSegments = location.pathname.split('/').filter(Boolean);
  
  // Build breadcrumb items
  const breadcrumbItems: Array<{ path: string; label: string; isLast: boolean }> = [];
  
  for (let i = 0; i < pathSegments.length; i++) {
    const path = '/' + pathSegments.slice(0, i + 1).join('/');
    const label = routeNameMap[path] || pathSegments[i];
    const isLast = i === pathSegments.length - 1;
    
    breadcrumbItems.push({ path, label, isLast });
  }

  if (breadcrumbItems.length <= 1) {
    return null; // Don't show breadcrumb for root admin page
  }

  return (
    <Breadcrumb>
      <BreadcrumbList>
        {breadcrumbItems.map((item, index) => (
          <div key={item.path} className="flex items-center">
            <BreadcrumbItem>
              {item.isLast ? (
                <BreadcrumbPage>{item.label}</BreadcrumbPage>
              ) : (
                <BreadcrumbLink href={item.path}>{item.label}</BreadcrumbLink>
              )}
            </BreadcrumbItem>
            {!item.isLast && <BreadcrumbSeparator />}
          </div>
        ))}
      </BreadcrumbList>
    </Breadcrumb>
  );
};